/**
 * Adapptio Core library.
 *
 * @package lib-core
 * @copyright 2021-2025 Hexio a.s. <contact@hexio.io> (hexio.io) and contributors.
 * @license Apache-2.0
 *
 * See LICENSE file distributed with this source code for more information.
 */

import {
	BP,
	ISchemaFlowNodeTypeOutputDefinitionMap,
	TGetBlueprintSchemaSpec
} from "@adapptio/lib-blueprint";
import { NODE_OUTPUTS, NODE_OUTPUT_NAMES, NODE_TYPES } from "./BlueprintNode";

export const BlueprintIntegrationNode = {
	name: NODE_TYPES.INTEGRATION,
	label: "Integration",
	opts: BP.Special.IntegrationRef({
		constraints: { required: true }
	}),
	editorOptions: {
		displayInPalette: false
	},
	resolveOutputs: (): ISchemaFlowNodeTypeOutputDefinitionMap => ({
		[NODE_OUTPUT_NAMES.ON_SUCCESS]: NODE_OUTPUTS.ON_SUCCESS,
		[NODE_OUTPUT_NAMES.ON_ERROR]: NODE_OUTPUTS.ON_ERROR
	})
};

export type TBlueprintIntegrationNodeOptsSchemaSpec = TGetBlueprintSchemaSpec<
	typeof BlueprintIntegrationNode["opts"]
>;
